<template>
  <el-container class="homePageContainer">
    <el-header class="headerBox">
      <!-- Logo -->
      <div class="logo-content" @click="logoClick">
        <img src="@/assets/image/logo-01.svg" class="logo-image" />
      </div>
      <!-- Menu Nav -->
      <el-menu
        @select="activeIndexSelect"
        :default-active="activeIndex"
        class="menu-nav-content"
        mode="horizontal"
      >
        <template v-for="(item, index) in homeNavMenuList">
          <el-menu-item
            v-if="item.children ? !item.children.length: true"
            :index="index + ''"
            :key="index"
            @click="navigatorTo(item)"
          >
            {{ item.menuName }}
          </el-menu-item>
          <el-submenu
            popper-class="submenuPopClass"
            v-else
            :index="index + ''"
            :key="index"
          >
            <template slot="title">
              <span slot="title">{{ item.menuName }}</span>
            </template>
            <el-menu-item-group v-for="(citem, ci) in item.children" :key="ci">
              <el-menu-item
                :index="index + '-' + ci"
                @click="navigatorTo(citem)"
              >
                {{ citem.menuName }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </template>
      </el-menu>
      <!-- Language & Info -->
      <div class="language-info-content">
        <!-- 我的应用 -->
        <el-popover
          popper-class="theCenterMyAppPopover specil"
          placement="top"
          trigger="hover"
        >
          <div class="theCenterMyApp">
            <div class="theOutBox">
              <div
                class="appBox"
                v-for="(item, index) in myClientList"
                :key="index"
              >
                <div @click="handleClick(item.clientId)">
                  <img :src="item.clientIconKey" alt="" />
                  <div class="theName">{{ item.clientName }}</div>
                </div>
              </div>
            </div>
          </div>
          <div slot="reference" class="myApp" @click="toMyApp" v-if="isLogin">
            <el-image
              :src="require('@/assets/image/myAppIcon.svg')"
              alt=""
            ></el-image>
            <span class="langu">{{ $t("PAGES.home.MyApps") }}</span>
          </div>
        </el-popover>
        <!-- 多语言选择 -->
        <div class="languageBox">
          <ChoseLang />
        </div>
        <!-- 用户信息 -->
        <div
          class="infoBox enterForYourInfo"
          @click="enterYouInfo"
          v-if="!isLogin"
        >
          <img
            src="@/assets/image/profilePhoto.svg"
            style="border-radius: 50%"
          />
          {{ $t("PAGES.layout.EnterYouInfo") }}
        </div>
        <div class="infoBox" v-if="isLogin">
          <el-dropdown trigger="click" @command="handleSetUser">
            <div>
              <img
                src="@/assets/image/profilePhoto.svg"
                style="border-radius: 50%"
              />
              <div class="userInfo">
                <span class="userName">{{ username }}</span>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown" class="theDropdownBox">
              <el-dropdown-item class="theHeadBox">
                <div class="theHead">
                  <div class="info fname">{{ username }}</div>
                  <div class="info email">{{ email }}</div>
                  <div class="info companyName">{{ companyName }}</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="Profile">
                <div class="toPack">
                  {{ $t("PAGES.layout.Profile") }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="Consumption">
                <div class="toPack">
                  {{ $t("PAGES.layout.Consumption") }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="LogOut" class="toDengChu">
                <div class="toPack" style="color: red">
                  {{ $t("PAGES.layout.LogOut") }}
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <el-container class="theElContainer">
      <router-view></router-view>
    </el-container>
    <CookieFooter v-show="isShowCookie"></CookieFooter>
    <!-- 二次确认弹框 -->
    <div class="twoConfirmDialog" v-show="logOutDialog">
      <div class="outBox">
        <span></span>
        <div class="theTitle">
          <span style="color: #ff9816" class="el-icon-warning"> </span>
          <span class="theContent">{{ $t("PAGES.layout.ConfirmLogout") }}</span>
        </div>
        <div class="theFooter">
          <el-button class="theCancel" @click="logOutDialog = false">{{
            $t("GLOBAL.Cancel")
          }}</el-button>
          <el-button class="theConfirm theRed" @click="toExit">
            {{ $t("GLOBAL.Exit") }}
          </el-button>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import { loadLanguageAsync, } from "@/lang/i18n";
import ChoseLang from "@/components/choseLang";
import CookieFooter from "@/pages/layout/cookieFooter.vue";
import axios from "axios";
import { formatDateTime } from '@/utils';
import qs from "qs";
const instance = axios.create({
  baseURL: "/",
});
import { queryEnabledLanguageCode, saveLocaleLanguageCode, queryClientByUserId, getRedirectUrl, getUserinfo } from "@/api/user/index.js";
import { queryEnabledMenuTree } from "@/api/backStagePage/index.js";
export default {
  components: {
    ChoseLang,
    CookieFooter
  },
  watch: {
    // 监听路由对象$route的变化
    $route: {
      handler: function (to, from) {
        if (to.path === '/home' || to.path === '/cookie-policy') {
          this.isShowCookie = true;
        } else {
          this.isShowCookie = false;
        }
      },
      // 注意deep和immediate选项
      deep: true,
      immediate: true,
    }
  },
  created() {
    this.userIsOrNotLogin();
    this.queryEnabledLanguageCode();
    this.getFooterNavs();
    this.$store.commit("SET_COOKIE_PREFERENCES", this.langType.slice(0, 2)); // 在当前页设置触发Cookie Preferences
    this.theLange = localStorage.getItem("lang") ? localStorage.getItem("lang").slice(0, 2) : 'en';
  },
  methods: {
    queryEnabledLanguageCode() {
      queryEnabledLanguageCode()
        .then((res) => {
          this.langList = res;
          this.$store.commit("SET_LANGUAGELIST", this.langList);
          this.userLang = "";
          if (localStorage.getItem("lang")) {
            this.userLang = localStorage.getItem("lang");
          } else {
            this.userLang = navigator.language || navigator.userLanguage;
          }
          this.userLang = this.userLang.split("-").join("_");
          saveLocaleLanguageCode({
            locale: this.userLang
          }).then(() => {
            this.getHomeNavMenuList();
          }).catch(() => {
            this.getHomeNavMenuList();
          });
          let flagI = this.langList.findIndex(
            (el) => el.languageCode === this.userLang
          );
          if (flagI >= 0) {
            localStorage.setItem("lang", this.userLang);
            loadLanguageAsync(this.userLang);
          } else {
            localStorage.setItem("lang", "en_GB");
            loadLanguageAsync("en_GB");
          }
        })
        .catch(() => {
          this.getHomeNavMenuList();
        });
    },
    handleClick(clientId) {
      getRedirectUrl({ clientId: clientId })
        .then((res) => {
          if (res.startsWith("http")) {
            // 判断返回值，开头是不是为http，如果不是就需要通过解密获取解密之后的结果，再模拟表单登录
            window.open(res);
          } else {
            let resObj = JSON.parse(decrypt3(res));
            let form = document.createElement("form");
            form.method = "POST"; // 设置表单提交的HTTP方法为POST
            form.target = "_blank"; // 设置表单提交之后打开新页面
            form.action = resObj.url; // 设置表单跳转的url
            delete resObj.url;
            const keys = Object.keys(resObj);
            keys.forEach((item) => {
              var input = document.createElement("input");
              input.type = "hidden";
              input.name = item;
              input.value = resObj[item];
              form.appendChild(input);
            });
            document.body.appendChild(form);
            this.$nextTick(() => {
              form.submit(); // 提交表单
            });
          }
        })
        .catch(() => {});
    },
    queryClientByUserId() {
      queryClientByUserId()
        .then((res) => {
          this.myClientList = res;
        })
        .catch(() => {
          this.myClientList = [];
        });
    },
    getFooterNavs() {
      if (
        localStorage.getItem("lang") &&
        localStorage.getItem("lang") !== "zh_CN"
      ) {
        this.langType = localStorage.getItem("lang");
      } else {
        this.langType = "en_GB";
      }
    },
    clickCookiePolicy(item) {
      if (item.value === "cookie-policy") {
        if (this.$route.fullPath === "/cookie-policy") {
          this.$router.push("/home");
        } else {
          this.$router.push("/cookie-policy");
        }
      }
    },
    toMyApp() {
      this.logoClick();
    },
    enterYouInfo() {
      this.logoClick();
    },
    userIsOrNotLogin() {
      // 中转验证：判断当前用户是否登录
      if (localStorage.getItem("token")) {
        this.username = this.$store.state.user.ucUserInfo.name;
        this.email = this.$store.state.user.ucUserInfo.email;
        this.companyName = this.$store.state.user.ucUserInfo.treePathName
          ? this.$store.state.user.ucUserInfo.treePathName.substring(
              this.$store.state.user.ucUserInfo.treePathName.lastIndexOf("/") +
                1
            )
          : "";
        this.isLogin = true;
        this.queryClientByUserId();
      } else {
        this.isLogin = false;
      }
    },
    toExit() {
      this.$store.commit("USER_SIGN_OUT");
      this.isLogin = false;
      this.logOutDialog = false;
    },
    handleSetUser(v) {
      // 登出、忘记密码
      if (v === "LogOut") {
        this.logOutDialog = true;
      } else if (v === "Profile") {
        let registerUrl =
          process.env.VUE_APP_IS_PRO === "notPro"
            ? `https://test-technicalinformation.fiat.com/regAuth/${this.theLange}/dashboard/user-profile?source=LPMI`
            : `https://technicalinformation.fiat.com/regAuth/${this.theLange}/dashboard/user-profile?source=LPMI`;
        window.open(registerUrl, "_blank");
      } else if (v === "Consumption") {
        this.activeIndex = "";
        this.$router.push("/consumption");
      }
    },
    logoClick() {
      // 点击logo，回到home首页
      this.activeIndex = "";
      this.$router.push("/home");
    },
    activeIndexSelect(v) {
      // menu选择
      this.activeIndex = v;
    },
    navigatorTo(item) {
      // 菜单栏选择navigatorTo
      if (item.menuId === "Purchase") {
        // ①临时方案：无论等不登录，都跳转展示“建设中”
        // this.$router.push("/purchase");
        // ②等商城系统确认没问题了，在解开下边代码
        if (this.isLogin) {
          // 直接调用户中心接口，跳转商城即可
          getRedirectUrl({ clientId: "LPSP" })
            .then((res) => {
              window.open(res);
            })
            .catch(() => {});
        } else {
          this.$router.push("/purchase");
        }
      } else if (item.menuId === "SERMI") {
        // 掉接口，判断是否认证且认证是否过期：
        getUserinfo().then(res => {
          if (res.securityStatus) { // 没过期
            let securityExpirationDate = res.securityExpirationDate ? formatDateTime(res.securityExpirationDate, 'datatime') : '';
            this.$message.success(`${this.$t("PAGES.layout.IsActived")}${securityExpirationDate}`);
          } else { // 过期
            // 1.如果用户信息中securitystep=true，跳转 profile 界面；
            if (res.securityStep) {
              let registerUrl =
              process.env.VUE_APP_IS_PRO === "notPro"
                ? `https://test-technicalinformation.fiat.com/regAuth/${this.theLange}/dashboard/user-profile?source=LPMI`
                : `https://technicalinformation.fiat.com/regAuth/${this.theLange}/dashboard/user-profile?source=LPMI`;
              window.open(registerUrl, "_blank");
            } else {
            // 2.如果用户信息中securitystep=false，跳转 SERMI 界面:
              let registerUrl =
              process.env.VUE_APP_IS_PRO === "notPro"
                ? `https://test-technicalinformation.fiat.com/proxyPage.html?mode=initSSO&spName=TISP&redirectURL=https%3A%2F%2Ftest-technicalinformation.fiat.com%2Ftech-info-web%2Fweb%2FpageLarge.do%3Fid%3D606%26source%3DLPMI%26request_locale%3d${this.theLange}`
                : `https://technicalinformation.fiat.com/proxyPage.html?mode=initSSO&spName=TISP&redirectURL=https%3A%2F%2Ftechnicalinformation.fiat.com%2Ftech-info-web%2Fweb%2FpageLarge.do%3Fid%3D706%26source%3DLPMI%26request_locale%3d${this.theLange}`;
              window.open(registerUrl, "_blank");
            }
          }
        }).catch(() => {});
        
      } else {
        this.$router.push({
          path: "/menuPage",
          query: {
            menuId: item.menuId,
          },
        });
      }
    },
    getHomeNavMenuList() {
      queryEnabledMenuTree().then(res => {
        let resTemp = JSON.parse(JSON.stringify(res));
        this.homeNavMenuList = resTemp;
        this.homeNavMenuList.push({
          menuId: "Purchase",
          menuName: this.$t("PAGES.layout.Purchase"),
          children: [],
        });
        if (localStorage.getItem("token")) {
            this.homeNavMenuList.push({
              menuId: "SERMI",
              menuName: this.$t("PAGES.layout.SERMI"),
              children: [],
            });
        }
      }).catch(() => {
        this.homeNavMenuList.push({
          menuId: "Purchase",
          menuName: this.$t("PAGES.layout.Purchase"),
          children: [],
        });
      });
    },
  },
  data() {
    return {
      username: "", // {{$store.state.user.ucUserInfo.name}}
      email: "", // {{$store.state.user.ucUserInfo.email}}
      companyName: "", // {{$store.state.user.ucUserInfo.treePathName}}
      isLogin: false,
      activeIndex: "",
      homeNavMenuList: [],
      logOutDialog: false,
      langType: "en_GB",
      theFooterNavs: [
        {
          value: "cookie-policy",
          label: this.$t("PAGES.layout.CookiePolicy"),
        },
        {
          value: "cookie-preferences",
          label: this.$t("PAGES.layout.CookiePreferences"),
        },
      ],
      myClientList: [],
      isShowCookie: true,
      userLang: "",
      langList: this.$store.state.user.languageList || localStorage.getItem('languageList'),
      theLange: 'en',
    };
  },
};
</script>
<style lang="scss" scoped>
.theCenterMyApp {
  padding: 2rem 0;
  .theOutBox {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    .appBox {
      width: 33.3%;
      cursor: pointer;
      text-align: center;
      .theName {
        margin-top: 1.1rem;
        margin-bottom: 3.2rem;
      }
    }
  }
  .appBox {
    cursor: pointer;
    .el-col-8 {
      text-align: center;
      .theName {
        margin-top: 1.1rem;
        margin-bottom: 3.2rem;
      }
    }
    img {
      width: 4.8rem;
      height: 4.8rem;
    }
  }
}
.homePageContainer{
  height: 100%;
}
.headerBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 3rem;
  height: 6.8rem !important;
  border-bottom: 1px solid #e9eef3;
  position: relative;
  background: #ffffff;
  position: relative;
  .logo-content {
    width: 24.5rem;
    height: 3.1rem;
    cursor: pointer;
    .logo-image {
      width: 100%;
      display: block;
    }
  }
  .menu-nav-content {
    height: 6.8rem !important;
    overflow: auto;
    .el-menu-item {
      font-size: 1.6rem;
    }
    .el-submenu {
      .el-submenu__title {
        span {
          font-size: 1.6rem;
        }
      }
    }
    .el-menu-item:hover {
      &::after {
        width: 0;
      }
    }
    .el-menu-item.is-active {
      background-color: #fff !important;
    }
  }
  .language-info-content {
    display: flex;
    .myApp {
      position: relative;
      margin-right: 1rem;
      cursor: pointer;
      width: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .el-image {
        width: 2.3rem;
        height: 2.3rem;
      }
      .langu {
        vertical-align: middle;
        font-size: 1.4rem;
        color: #000;
        margin-top: 0.5rem;
      }
    }
    .enterForYourInfo {
      font-size: 1.4rem;
      img {
        margin: 0 1rem;
      }
    }
    .infoBox {
      cursor: pointer;
      display: flex;
      align-items: center;
      .el-dropdown-selfdefine {
        display: flex;
        margin-left: 1rem;
      }
      img {
        width: 3.8rem;
        height: 3.8rem;
      }
      .userInfo {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 1.2rem;
        .userName {
          font-size: 1.7rem;
          color: #002226;
          white-space: nowrap;
        }
        .jobName {
          font-size: 1.7rem;
          color: #787f83;
        }
      }
    }
  }
}
.theElContainer {
  height: calc(100% - 6.8rem);
  padding: 1.2rem;
  background: #eeeeee;
}
.footer {
  background: #000000;
  color: #ffffff;
  font-size: 1.6rem;
  position: fixed;
  width: 100%;
  bottom: 0;
  a {
    color: #ffffff !important;
  }
  span {
    display: inline-block;
    height: 6rem;
    line-height: 6rem;
    padding: 0 1rem;
    margin: 0 1rem;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.theCenterMyAppPopover {
  width: 32rem !important;
  border-radius: 1rem;
}
.theDropdownBox {
  border-radius: 1.6rem !important;
  padding: 0 !important;
  .theTwo,
  .el-dropdown-menu__item {
    padding: 0 !important;
    border-bottom: 0.1rem solid rgba(151, 151, 151, 0.26);
  }
  .el-dropdown-menu__item {
    font-size: 1.4rem;
    div.toPack {
      padding: 0 2.1rem;
      height: 4.3rem;
      line-height: 4.3rem;
    }
    span.line {
      display: inline-block;
      width: 90%;
      height: 0.1rem;
      background: #d8d8d8;
      position: absolute;
      left: 2rem;
    }
  }
  .theHeadBox {
    font-size: 1.6rem;
    border-top-left-radius: 1.6rem;
    border-top-right-radius: 1.6rem;
    background: #f2f2f2;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
    border-bottom: 0.1rem solid rgba(151, 151, 151, 0.26);
    .theHead {
      padding: 1rem 2rem;
      width: 28.3rem;
      word-wrap: break-word;
      overflow-wrap: break-word;
      .info {
        line-height: normal;
        margin: 0.3rem 0;
      }
    }
  }
  .toDengChu {
    border-bottom-left-radius: 1.6rem;
    border-bottom-right-radius: 1.6rem;
  }
  .el-dropdown-menu__item:not(.is-disabled):hover {
    color: var(--themColor) !important;
  }
}
.submenuPopClass {
  .el-menu--popup {
    .el-menu-item-group {
      .el-menu-item {
        font-size: 1.6rem;
      }
      .el-menu-item:hover {
        &::after {
          width: 0;
        }
      }
    }
  }
}
@import url("@/common/css/layout.scss");
</style>